(function () {
  'use strict';
  if (window.__lynkSeasonalStockV28Loaded) return;
  window.__lynkSeasonalStockV28Loaded = true;
  let retainedHost = null;
  let observer = null;
  let observedRoot = null;
  let pendingHost = null;
  let queued = false;
  let suspended = false;
  const seasonalRoot = () => document.querySelector('.lynk-seasonal-product-v28');
  const stopWatching = () => { observer?.disconnect(); observedRoot = null; };
  const liveHost = () => pendingHost?.isConnected ? pendingHost
    : document.getElementById('nm-btn-container') || retainedHost;
  function place() {
    if (suspended) return false;
    const root = seasonalRoot();
    if (!root) return false;
    const form = root.querySelector('product-form[data-main="true"]');
    const host = liveHost();
    if (!form || !host) return false;
    let slot = root.querySelector('[data-lynk-seasonal-stock-slot]');
    if (!slot) {
      slot = document.createElement('div');
      slot.className = 'lynk-seasonal-stock-action';
      slot.dataset.lynkSeasonalStockSlot = '';
      form.after(slot);
    }
    // App rerenders can replace or reparent this exact listener-bearing node.
    // Never rebuild its contents or replace its event handlers.
    // A delayed replacement can arrive after we restored the previous host.
    // Retire that superseded node so only the app's current launcher remains.
    if (retainedHost && retainedHost !== host && retainedHost.isConnected) retainedHost.remove();
    if (host.parentNode !== slot) slot.append(host);
    retainedHost = host;
    pendingHost = null;
    root.dataset.lynkStockPlacement = 'inline';
    return true;
  }
  function queuePlacement() {
    if (queued || suspended) return;
    const root = observedRoot?.isConnected ? observedRoot : seasonalRoot();
    if (!root) { stopWatching(); return; }
    const host = liveHost();
    const slot = root.querySelector('[data-lynk-seasonal-stock-slot]');
    // Our own append is observed too, but the restored invariant is a no-op.
    if (!host || (slot && host.parentNode === slot)) return;
    queued = true;
    queueMicrotask(() => { queued = false; place(); });
  }
  function watch(root) {
    if (observedRoot === root) return;
    stopWatching();
    if (!observer) observer = new MutationObserver(records => {
      for (const record of records) for (const node of record.addedNodes) {
        if (node.nodeType !== 1) continue;
        const host = node.id === 'nm-btn-container' ? node : node.querySelector('#nm-btn-container');
        if (host?.isConnected) pendingHost = host;
      }
      queuePlacement();
    });
    observedRoot = root;
    // Native app reparenting lands at BODY. Product rerenders stay in this root.
    // Observe these two bounded targets, not the whole document subtree.
    observer.observe(document.body, { childList: true });
    observer.observe(root, { childList: true, subtree: true });
  }
  function initialize() {
    const root = seasonalRoot();
    if (!root || suspended) { stopWatching(); return; }
    const rewardsLink = Array.from(document.querySelectorAll('header a[href]')).find(link => {
      try { return new URL(link.href, location.href).pathname.replace(/\/$/, '') === '/pages/lynk-universe' && /rewards\s+programme/i.test(link.textContent); }
      catch (_) { return false; }
    });
    document.body.classList.toggle('lynk-seasonal-rewards-in-menu', Boolean(rewardsLink));
    watch(root);
    place();
  }
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('change', event => {
    if (event.target.closest?.('.lynk-seasonal-product-v28')) queuePlacement();
  });
  window.addEventListener('pageshow', () => { suspended = false; initialize(); });
  window.addEventListener('pagehide', () => { suspended = true; pendingHost = null; stopWatching(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
}());
